import { EnvironmentEnum } from "src/app/constants/environment.enum";
import { PKIBrandingDomainURLs } from "src/app/constants/Urls/branding-domains.urls";

export const environment = {
  production: true,
  apiUrl: "https://platformapi.pkisigning.io",
  identityUrl: "https://identity.pkisigning.io",
  signingApiUrl: "https://engine.pkisigning.io",
  platformname: EnvironmentEnum.Production,
  domain: PKIBrandingDomainURLs.ProductionBrandingUrl,
  enableTaxPaymentIntegration:true,
  applicationInsightsKey: "db02ead0-9161-41f0-b70b-523f4138daf7",
  applicationFullName: "PlatformV2PKIsigning"
};
